// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".has-border-bottom-grey-light{border-bottom:1px solid #dbdbdb}.color-tertiary{color:#2cd5c4}.color-primary{color:#ef4a81}.color-grey-darker{color:#363636}.color-grey{color:#7a7a7a}.help.is-danger{position:static}.link-other-experiences{font-weight:500;color:#ef4a81;text-decoration:underline}.link-other-experiences:hover{font-weight:500;color:#f11e64;text-decoration:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
